import React, { useState } from "react";
import { HiOutlineLocationMarker, HiOutlineBriefcase, HiOutlineCurrencyDollar, HiOutlineExternalLink } from "react-icons/hi";
import { HiChevronDown, HiChevronUp } from "react-icons/hi2";

const JobCard = ({ job }) => {
  const [showMore, setShowMore] = useState(false);

  const handleApply = () => {
    window.open(job.applyLink, '_blank');
  };

  return (
    <div className="group bg-white border border-slate-100 rounded-[2rem] shadow-sm hover:shadow-xl hover:border-blue-100 transition-all duration-300 flex flex-col h-full overflow-hidden">

      {/* 1. Header & Badge */}
      <div className="p-6 pb-0 flex justify-between items-start">
        <span className="text-[10px] font-black uppercase tracking-[0.2em] text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
          {job.tag || "New Opening"}
        </span>
        <div className="w-10 h-10 bg-slate-50 rounded-xl flex items-center justify-center border border-slate-100 text-slate-400 group-hover:text-blue-500 transition-colors">
          <HiOutlineBriefcase size={20} />
        </div>
      </div>

      {/* 2. Main Info */}
      <div className="p-6 pt-4 flex-grow">
        <h2 className="text-xl font-black text-slate-900 leading-tight group-hover:text-blue-600 transition-colors">
          {job.title}
        </h2>
        <p className="text-slate-500 font-bold text-sm mt-1">{job.company}</p>

        {/* Info Grid */}
        <div className="grid grid-cols-2 gap-3 mt-6">
          <div className="flex items-center gap-2 text-slate-400">
            <HiOutlineLocationMarker size={16} />
            <span className="text-xs font-bold truncate">{job.location || "Remote"}</span>
          </div>
          <div className="flex items-center gap-2 text-slate-400">
            <HiOutlineCurrencyDollar size={16} />
            <span className="text-xs font-bold">{job.salary || "Competitive"}</span>
          </div>
        </div>

        {/* 3. Expandable Description */}
        <div className="mt-6 relative">
          <div
            className={`text-sm text-slate-600 leading-relaxed transition-all duration-300 ${showMore ? "max-h-[1000px]" : "max-h-20 line-clamp-3"}`}
            dangerouslySetInnerHTML={{ __html: job.description }}
          />

          <button
            onClick={() => setShowMore(!showMore)}
            className="mt-2 flex items-center gap-1 text-[11px] font-black text-blue-500 uppercase tracking-widest hover:text-blue-700 transition-colors"
          >
            {showMore ? (
              <>Show Less <HiChevronUp /></>
            ) : (
              <>Read Requirements <HiChevronDown /></>
            )}
          </button>
        </div>
      </div>

      {/* 4. Action Footer */}
      <div className="p-4 bg-slate-50 border-t border-slate-100 group-hover:bg-blue-50 transition-colors">
        <button
          onClick={handleApply}
          className="w-full bg-slate-900 text-white py-4 rounded-2xl font-black text-sm flex items-center justify-center gap-2 hover:bg-blue-600 transition-all active:scale-95 shadow-lg shadow-slate-100 hover:shadow-blue-100"
        >
          Apply Now
          <HiOutlineExternalLink size={18} />
        </button>
      </div>
    </div>
  );
};

export default React.memo(JobCard);